module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#environment",
      toString: function () {
        return this.url;
      }
    }